export const loadState = (key) => {
    try{
        const serializedItem = localStorage.getItem(key);
        if(serializedItem === null){
            return null;
        }
        return JSON.parse(serializedItem);
    }catch (e) {
        return null;
    }
}

export const saveState = (key, data) => {
    try {
        const serializedItem = JSON.stringify(data);
        localStorage.setItem(key, serializedItem);
    }catch (e) {

    }
}
